/**
 * Warning: this code will give you a headache.
 * See: https://skydreams.tpondemand.com/entity/14836
 * Please note that this diagram is not 100% anymore (self changed is not right I think?)
 */
angular.module('b2bLoginApp').directive('sdIndeterminate', function () {
    return {
        restrict: 'A',
        link: function ($scope) {
            $scope.$on('sd-change', function(event, args) {
                event.stopPropagation();
                var typeId = args[0];
                var newVal = args[1];

                if (typeof $scope.region.parentRegion !== 'undefined') {
                    updateParentRegion($scope.region.parentRegion, typeId, newVal);
                }

                angular.forEach($scope.region.__children, function(childRegion) {
                    updateChildRegion(childRegion, typeId, newVal);
                });
            });

            function updateParentRegion(region, typeId, newVal) {
                var self = region.types[typeId];
                var assign = null;
                var allFalse = null;
                var children = null;
                var key = null;
                var child = null;

                if (newVal === true && self === false) {
                    assign = 'child';
                    log(region, 'child', 'false > child');
                }
                if (newVal === false) {
                    allFalse = true;
                    children = region.__children;
                    for (key in children) {
                        child = children[key];
                        if (child.types[typeId] !== false) {
                            allFalse = false;
                            break;
                        }
                    }
                    if (self === 'child' && allFalse) {
                        assign = false;
                        log(region, 'child', 'child > false');
                    }
                }
                if (newVal === 'parent' && self === false) {
                    assign = 'child';
                    log(region, 'child', 'parent > child');
                }
                if (newVal === 'child' && self === false) {
                    assign = 'child';
                    log(region, 'child', 'self  > child');
                }
                if (newVal === 'child_deselect') {
                    allFalse = true;
                    children = region.__children;
                    for (key in children) {
                        child = children[key];
                        if (child.types[typeId] !== false) {
                            allFalse = false;
                            break;
                        }
                    }
                    assign = allFalse ? false : 'child';
                    log(region, 'child', 'child_deselect  > '+assign);
                    region.types[typeId] = assign;
                    if (typeof region.parentRegion !== 'undefined') {
                        updateParentRegion(region.parentRegion, typeId, 'child_deselect');
                    }
                    angular.forEach(region.__children, function(childRegion) {
                        updateChildRegion(childRegion, typeId, 'child_activate');
                    });
                    return;
                }

                if (assign !== null) {
                    region.types[typeId] = assign;

                    if (typeof region.parentRegion !== 'undefined') {
                        updateParentRegion(region.parentRegion, typeId, assign);
                    }
                }
            }

            function updateChildRegion(region, typeId, newVal) {
                var self = region.types[typeId];
                var assign = null;

                if (newVal === true) {
                    assign = 'parent';
                    log(region, 'parent', 'self > parent');
                }
                if (newVal === false) {
                    assign = false;
                    log(region, 'parent', 'self > false');
                }
                if (newVal === 'parent') {
                    assign = 'parent';
                    log(region, 'parent', 'self > parent');
                }
                if (newVal === 'child_deselect') {
                    assign = false;
                    log(region, 'parent', 'child_deselect > false');
                }
                if (newVal === 'child_activate' && self === 'parent') {
                    assign = true;
                    log(region, 'parent', 'child_activate > true');
                }
                if (assign !== null) {
                    region.types[typeId] = assign;

                    angular.forEach(region.__children, function(childRegion) {
                        updateChildRegion(childRegion, typeId, assign);
                    });
                }
            }
        }
    };

    function log() {
        // console.log(arguments);
    }
});
